import { render, staticRenderFns } from "./LcProxyMonthData.vue?vue&type=template&id=637f7bc6&scoped=true"
import script from "./LcProxyMonthData.vue?vue&type=script&lang=js"
export * from "./LcProxyMonthData.vue?vue&type=script&lang=js"
import style0 from "./LcProxyMonthData.vue?vue&type=style&index=0&id=637f7bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f7bc6",
  null
  
)

export default component.exports